import { useMemo } from 'react';
import { useQuizzStore } from '../stores';
import { DateTime } from 'luxon';

export const useAvailableQuizzState = () => {
  const { availableAt, availableUntil } = useQuizzStore();

  const isActive = useMemo(() => {
    if (!availableAt || !availableUntil) {
      return false;
    }

    const parsedAvailableAt = DateTime.fromISO(availableAt).toUTC();
    const parsedAvailableUntil = DateTime.fromISO(availableUntil).toUTC();
    const now = DateTime.utc();

    return now >= parsedAvailableAt && now <= parsedAvailableUntil;
  }, [availableAt, availableUntil]);

  return isActive;
};
